import { HttpClient } from '@angular/common/http';
import { inject, Injectable, isDevMode } from '@angular/core';
import {
  provideTransloco,
  Translation,
  translocoConfig,
  TranslocoLoader,
  TranslocoService,
} from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/i18n/${lang}.json`);
  }
}

export function provideEcosEternosI18n() {
  return provideTransloco({
    config: translocoConfig({
      availableLangs: ['es', 'en', 'pt'],
      defaultLang: 'es',
      // Remove this option if your application doesn't support changing language in runtime.
      reRenderOnLangChange: true,
      prodMode: !isDevMode(),
      fallbackLang: 'es',
    }),
    loader: TranslocoHttpLoader,
  });
}

@Injectable({
  providedIn: 'root',
})
export class I18nService {
  private translocoService = inject(TranslocoService);
  private readonly LANG_KEY = 'ee-lang';

  constructor() {
    this.initLanguage();
  }

  private initLanguage() {
    // 1. Check local storage
    const savedLang = localStorage.getItem(this.LANG_KEY);
    if (savedLang && ['es', 'en', 'pt'].includes(savedLang)) {
      this.translocoService.setActiveLang(savedLang);
      return;
    }

    // 2. Check browser language
    const browserLang = navigator.language.split('-')[0].toLowerCase();
    if (['es', 'en', 'pt'].includes(browserLang)) {
      this.translocoService.setActiveLang(browserLang);
      return;
    }

    // Default is 'es'
    this.translocoService.setActiveLang('es');
  }

  setLanguage(lang: 'es' | 'en' | 'pt') {
    this.translocoService.setActiveLang(lang);
    localStorage.setItem(this.LANG_KEY, lang);
  }

  getActiveLang(): string {
    return this.translocoService.getActiveLang();
  }
}
